// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"585ba9df","513":"9d42741e","703":"e379e729","787":"627756db"}[chunkId] + ".chunk.js";
};